"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var route_settings_1 = require("@reverbdotcom/commons/dist/route_settings");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
var experiment_switch_1 = require("@reverbdotcom/commons/dist/components/experiment_switch");
var constants_1 = require("../components/shared/constants");
var ShopRoutes = (React.createElement(route_settings_1.Route, { key: "shop/:shop", path: "shop/:shop", getComponent: function (_location, cb) {
        require.ensure([], function (require) {
            cb(null, require('../components/discovery/shops/shop_container_exp').default);
        }, 'shop');
    } },
    React.createElement(route_settings_1.IndexRoute, { props: {
            pageViewEvent: function (_a) {
                var params = _a.params;
                return ({
                    pageName: mparticle_tracker_1.MParticlePageName.Shop,
                    shopSlug: params.shop,
                });
            },
        }, getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                cb(null, require('../components/marketplace/shop_page').default);
            }, 'shop');
        } }),
    React.createElement(route_settings_1.Route, { key: "feedback", path: "feedback", getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                var ExperimentComponent = require('../components/discovery/shops/shop_feedback').default;
                var DefaultComponent = require('../components/discovery/shops/shop_feedback_old').default;
                cb(null, function (props) {
                    return React.createElement(experiment_switch_1.default, { defaultComponent: React.createElement(DefaultComponent, tslib_1.__assign({}, props)), experimentComponent: React.createElement(ExperimentComponent, tslib_1.__assign({}, props)), experimentName: constants_1.experiments.REACT_SHOP });
                });
            }, 'shop');
        } }),
    React.createElement(route_settings_1.Route, { key: "about", path: "about", getComponent: function (_location, cb) {
            require.ensure([], function (require) {
                var ExperimentComponent = require('../components/discovery/shops/shop_info').default;
                cb(null, function (props) {
                    return React.createElement(experiment_switch_1.default, { defaultComponent: null, experimentComponent: React.createElement(ExperimentComponent, tslib_1.__assign({}, props)), experimentName: constants_1.experiments.REACT_SHOP });
                });
            }, 'shop');
        } })));
exports.ShopRoutes = ShopRoutes;
//# sourceMappingURL=shop.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/routes/shop.js
// module id = EfHr
// module chunks = 20 21